import { Utils } from "../Utils";

class DashService {
    static requestLoginCode(tel, pid, activationType) {
        return Utils.apiCallWithParsing({
            action: 'requestLoginCode',
            tel,
            pid,
            activationType
        })
    }

    static login(key, pin) {
        return Utils.apiCallWithParsing({
            action: 'login',
            key,
            pin
        });
    }

    static logout(token) {
        return Utils.apiCallWithParsing({
            action: 'logout',
            token
        });
    }

    static tokenLogin(token) {
        return Utils.apiCallWithParsing({
            action: 'tokenLogin',
            token
        });
    }

    static openClaim(token, policyId) {
        return Utils.apiCallWithParsing({
            action: 'openClaim',
            token,
            policyId
        });
    }

    static generateToken(token, data) {
        return Utils.apiCall({
            ...data,
            action: 'generateCCToken',
            token
        })
            .then(res => {
                return res.json()
            })
            .catch(ex => {
                throw Error("קיימת בעית תקשורת זמנית, ניתן לנסות שוב בעוד זמן קצר")
            });
    }

    static processPaymentDetails(dispatcher, state, data) {
        return DashService.generateToken(state._token, data)
            .then((data) => {
                return data;
            });
    }

    static getClaimData(token, claimId){
        return Utils.apiCallWithParsing({
            action: 'getClaimData',
            token,
            claimId
        });
    }
}

export { DashService }